module.exports = __webpack_public_path__ + "img/oc-unlock.cb742cdd.svg";